import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";

export interface AvailableAccessRights extends API_KeyValueData {
  value?: API_ACCESSRIGHTSENTRY_ACCESSLEVEL;
}

export class AvailableAccessRightsStore extends CoreStore {
  data: AvailableAccessRights[] = [];

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      clear: action,
      fetch: action.bound,
    });
  }

  url() {
    return API_URL.FOLDERS.getAvailableFolderRights(projectsDataStore.projectId);
  }

  clear() {
    this.data = [];
  }

  @handleStoreState()
  async fetch() {
    try {
      const response: AvailableAccessRights[] = await API.getData(this.url());
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      throw error;
    }
  }
}

export const availableAccessRightsStore = new AvailableAccessRightsStore();
